/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './statistics.scss';

/*@ngInject*/
export default function StatisticsController($q, $scope, $mdDialog, entityId, statisticsConfiguration) {

    var vm = this;

    vm.$onInit = function () {

        vm.statisticsConfiguration = statisticsConfiguration;
        vm.metrics = vm.statisticsConfiguration.metrics;
        vm.subEntities = vm.statisticsConfiguration.subEntities;

        vm.loading = false;
        vm.maxDate = new Date();
        vm.date = vm.maxDate;

        vm.timeRanges = [
            {
                key: "day",
                title: 'statistics.day',
                getValue: (date) => date.toISOString().slice(0, 10)
            },
            {
                key: "month",
                title: 'statistics.month',
                getValue: (date) => date.toISOString().slice(0, 7)
            }
        ];

        vm.cancel = cancel;

        createHeaders();
        loadMetrics();
    };

    const combinedName = (subEntity, timerange) => `${subEntity}_${timerange}`;

    const createHeaders = () => {
        let headers = [];
        vm.subEntities.forEach((subEntity) => {
            vm.timeRanges.forEach((timerange) => {
                headers.push({
                    key: combinedName(subEntity.key, timerange.key),
                    title: timerange.title
                })
            })
        });
        vm.headers = headers;
    }

    $scope.$watch("vm.date", function (newVal, prevVal) {
        if (!angular.equals(newVal, prevVal)) {
            loadMetrics();
        }
    });

    function loadMetrics() {
        if (entityId) {
            vm.loading = true;

            let metricsValues = {};
            let tasks = [];

            vm.timeRanges.forEach((timerange) => {
                let timeline = { [timerange.key]: timerange.getValue(vm.date) };
                vm.subEntities.forEach((subEntity) => {
                    let name = combinedName(subEntity.key, timerange.key)
                    metricsValues[name] = {};
                    vm.metrics.forEach(metric => {
                        tasks.push(vm.statisticsConfiguration.method(entityId, subEntity.key, metric.key, timeline).then(
                            (response) => { metricsValues[name][metric.key] = response }, () => { }
                        ));
                    })
                })
            })
            return $q.all(tasks).then(function success() {
                vm.metricsValues = metricsValues;
                vm.loading = false;
            }, function fail() {
                vm.loading = false;
            });
        }
    }

    function cancel() {
        $mdDialog.cancel();
    }
}


// WEBPACK FOOTER //
// ./src/app/statistics/statistics.controller.js